import { Box, Link, Typography } from '@material-ui/core';
import cx from 'classnames';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import FountainLogo from './fountain-logo.svg';
import { useStyles } from './styles';

export interface FooterProps {
  hasSidebar?: boolean;
  helpEmail?: string | null;
  isAmazonAccount?: boolean;
  isUpsAccount?: boolean;
}

export const Footer: React.VFC<FooterProps> = ({
  hasSidebar,
  helpEmail,
  isAmazonAccount,
  isUpsAccount,
}) => {
  const classes = useStyles();
  const intl = useIntl();

  const showHelpEmail = helpEmail && !isAmazonAccount;
  const isIframe = window.location !== window.parent.location;
  const linkToPrivacyPolicy = isUpsAccount
    ? 'https://www.jobs-ups.com/faqs-privacy'
    : 'https://web.fountain.com/privacy.html';

  return (
    <footer
      className={cx(classes.footer, { [classes.withSidebar]: hasSidebar })}
    >
      {showHelpEmail && (
        <Box my={6}>
          <Typography variant="body1">
            <FormattedMessage
              defaultMessage="Having Trouble?"
              description="Message for people who need assistance"
            />
          </Typography>
          <Typography>
            <Link
              className={classes.footerLink}
              href={`mailto:${helpEmail}`}
              target={isIframe ? '_blank' : undefined}
            >
              {helpEmail}
            </Link>
          </Typography>
        </Box>
      )}
      <Box my={6}>
        <Typography variant="caption">
          <FormattedMessage
            defaultMessage="Powered By"
            description="Caption to indicate who the form is powered by"
          />
        </Typography>
        <div>
          <img
            src={FountainLogo}
            alt={intl.formatMessage({
              defaultMessage: 'Fountain Logo',
              description: 'Icon for Fountain logo',
            })}
          />
        </div>
      </Box>
      <Box my={6}>
        <Typography variant="body1">
          <Link
            className={classes.footerLink}
            href={linkToPrivacyPolicy}
            target={isIframe ? '_blank' : undefined}
            rel="noopener"
          >
            {isUpsAccount && (
              <FormattedMessage
                defaultMessage="UPS Privacy Policy"
                description="Link to the UPS Privacy Policy"
              />
            )}
            {!isUpsAccount && (
              <FormattedMessage
                defaultMessage="Privacy Policy"
                description="Link to the Privacy Policy"
              />
            )}
          </Link>
          |
          <Link
            className={classes.footerLink}
            href="https://web.fountain.com/tos.html"
            target={isIframe ? '_blank' : undefined}
            rel="noopener"
          >
            <FormattedMessage
              defaultMessage="Terms of Service"
              description="Link to the Terms of Service"
            />
          </Link>
        </Typography>
      </Box>
    </footer>
  );
};
